import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-agility-date',
  templateUrl: './agility-date.component.html',
  standalone: false,
})
export class AgilityDateComponent implements OnInit {
  @Input() date!: number;
  constructor() {}

  ngOnInit(): void {}
}
